import { Utils } from 'ecrion-components';
export function selectWidgets(dashboardState) {
  var result = [];

  if (dashboardState.content) {
    dashboardState.content.dashboard.pages.forEach(function (page) {
      page.widgets.forEach(function (widget) {
        result.push({
          type: widget.elementName,
          name: widget.caption.title || Utils.formatting.camelCaseToWords(widget.elementName),
          id: widget.id
        });
      });
    });
  }

  return result;
}
export function selectWidget(content, widgetId) {
  for (var pageIndex = 0; pageIndex < content.dashboard.pages.length; pageIndex++) {
    var currentPage = content.dashboard.pages[pageIndex];

    for (var widgetIndex = 0; widgetIndex < currentPage.widgets.length; widgetIndex++) {
      var currentWidget = currentPage.widgets[widgetIndex];
      if (currentWidget.id === widgetId) return currentWidget;
    }
  }

  return null;
}